import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { getAllDataWithFlag, Savemenudata, getmenubyId } from "../../../services/CommonService";




const Settings = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [menuIdsFromApi, setMenuIdsFromApi] = useState([]);
    const [error, setError] = useState(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [menuRights, setMenuRights] = useState({});

    useEffect(() => {
        fetchContacts();
    }, []);


    const fetchContacts = async () => {
        try {
            setLoading(true);
            // Replace with your actual API endpoint
            const response = await getAllDataWithFlag(13);
            if (!response.status == 200) {
                throw new Error('Failed to fetch contacts');
            }
            const data = response.data;
            setContacts(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || err?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };


    const handleCheckboxChange = (menuId) => {
        setMenuRights((prev) => ({
            ...prev,
            [menuId]: !prev[menuId]
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            role_id: selectedRole,
            rights: menuRights
        };
        try {
            let response;
            response = await Savemenudata(payload);
            if (response.status == 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: `${response.data.message}`,
                });
            }
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || err?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };



    const handleRoleChange = async (e) => {
        const roleId = e.target.value;
        setSelectedRole(roleId);
        if (roleId) {
            try {
                const response = await getmenubyId(roleId);
                const data = await response.data;
                const rightsMap = {};
                data.forEach(item => {
                    if (item.can_display) {
                        rightsMap[item.menu_id] = true;
                    }
                });
                setMenuRights(rightsMap);
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error?.response?.data?.message || error?.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        }
    };




    return (
        <div className="container-fluid mt-4">
            <div className="card shadow">
                <div className="card-header adminCardHeader d-flex justify-content-between text-white">
                    <h4>User Rights</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <label className="me-2 mb-0">Role:</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={selectedRole}
                                        onChange={handleRoleChange}
                                        style={{ width: "150px" }}
                                        required
                                    >
                                        <option value="">Select Role</option>
                                        {
                                            contacts?.role?.filter((r) => r.name !== 'Super Admin' && r.name !== 'Admin')
                                                .map((r) => (
                                                    <option key={r.id} value={r.id}>
                                                        {r.name}
                                                    </option>
                                                ))}

                                    </select>
                                </div>
                            </div>
                        </div>

                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Menu Name</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contacts?.menu?.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.name}</td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={menuRights[item.id] || false}
                                                onChange={() => handleCheckboxChange(item.id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="text-end">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Settings;